<template>
    <div class="product">
        <BasicInfo :basic-info="basicInfo" @changeProduct="changeProduct"></BasicInfo>

        <DetailInfo :detail-info="detailInfo"></DetailInfo>

        <ProductList :product-list="recommendedProducts"></ProductList>
    </div>
</template>

<script>
    import BasicInfo from '../components/container/product/BasicInfo'
    import DetailInfo from '../components/container/product/DetailInfo'
    import ProductList from '../components/common/ProductList'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'product',
        data() {
            return {
                currentProductSlug: '',
            }
        },
        components: {
            BasicInfo,
            DetailInfo,
            ProductList,
        },
        computed: {
            ...mapState('product', {
                basicInfo: ({basicInfo, currentProductSlug}) => {
                    if (!basicInfo) return {}
                    const banners = basicInfo.main_pics.map(src => {
                        return {
                            imgSrc: src
                        }
                    })

                    let similar_products = basicInfo.similar_products.map(product => {
                        if (currentProductSlug === product.slug) {
                            return {
                                parentPath: '/product/',
                                imgSrc: product.cover_picture,
                                name: product.product_name,
                                slug: product.slug,
                                active: 'active',
                            }
                        }

                        return {
                            parentPath: '/product/',
                            imgSrc: product.cover_picture,
                            name: product.product_name,
                            slug: product.slug,
                            active: '',
                        }
                    })

                    const lang = localStorage.getItem('lang') || 'cn'

                    return {
                        banners,
                        tags: lang === 'cn' ? basicInfo.tags[0] && basicInfo.tags[0].cn_name : basicInfo.tags[0] && basicInfo.tags[0].en_name ,
                        name: basicInfo.product_name,
                        price: basicInfo.price,
                        series: {
                            name: basicInfo.category.category_info.name,
                            label: basicInfo.category.subcategory_info.name,
                            alias: lang === 'cn' ? basicInfo.category.category_info.en_name + ' ' + basicInfo.category.subcategory_info.en_name : basicInfo.category.category_info.cn_name + ' ' + basicInfo.category.subcategory_info.cn_name,
                            cnName: basicInfo.category.category_info.cn_name,
                            enName: basicInfo.category.category_info.en_name + ' ' + basicInfo.category.subcategory_info.en_name,
                        },
                        desc: basicInfo.product_description,
                        style: {
                            title: basicInfo.other_style_title + '（' + similar_products.length + '）',
                            items: similar_products,
                        },
                        miniprogram: {
                            title: basicInfo.shop_at_title,
                            imgSrc: basicInfo.buy_link.mini_program_qrcode
                        },
                        display_properties: {
                            title: lang === 'cn' ? '产品信息' : 'Product Info',
                            properties: basicInfo.product_information
                        },
                        // color: '颜色： 鎏金翠玉 / 白金白玉 ',
                        // size: '型号：MCG110A01-00',
                    }
                },
                detailInfo: ({detailInfo}) => {
                    return detailInfo.content.map(item => {
                        let banners = []

                        if (item.acf_fc_layout === 'pics') {
                            banners = item.gallery.map(img => {
                                return {
                                    isPic: true,
                                    imgSrc: img,
                                    isVideo: false,
                                    video: {}
                                }
                            })
                        }

                        if (item.acf_fc_layout === 'video') {
                            banners = [
                                {
                                    isPic: false,
                                    isVideo: true,
                                    video: {
                                        ref: 'storyVideo',
                                        videoSrc: item.video,
                                        loop: true,
                                        muted: true,
                                        autoplay: true,
                                    }
                                }
                            ]
                        }


                        return {
                            type: item.acf_fc_layout,
                            text: item.text,
                            banners,
                        }
                    })
                },
                recommendedProducts: ({products}) => {
                    const items = products.map(product => {
                        return {
                            parentPath: '/product/',
                            tags: product.tags,
                            slug: product.slug,
                            imgSrc: product.cover_picture,
                            title: product.category_name,
                            label: product.subcategory_name,
                            desc: [
                                {
                                    text: product.product_name,
                                },
                                {
                                    text: product.price,
                                }
                            ]
                        }
                    })

                    const lang = localStorage.getItem('lang') || 'cn'

                    return {
                        title: lang === 'cn' ? '为您推荐以下类似风格的饰品' : 'SELECTED PRODUCTS FOR YOU',
                        reload: true,
                        items: items
                    }
                },
            })
        },
        methods: {
            ...mapActions('product', ['getProduct']),
            changeProduct(slug) {
                this.getProduct(slug)
                this.currentProductSlug = slug
                this.$router.push({
                    path:'/product/' + slug
                })
            }
        },
        created() {
            this.getProduct(this.$route.params.id)
            this.currentProductSlug = this.$route.params.id
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .product {
        padding-top: 76px;

        /deep/ .list {
            .title {
                padding: 150px 0 0 0;
            }
        }
    }
</style>
